export { default, Thumbs } from "./Thumbs";
